import React, { useEffect, useState } from "react";
import { api, setReauthHandler, formatApiError } from "@/lib/api";
import { ShieldCheck, Loader2, X } from "lucide-react";

// Global step-up reauth modal. Registers itself with the api interceptor so any
// 403 "Reauthentication required" response pauses, prompts, then retries.
export const ReauthModal = () => {
  const [open, setOpen] = useState(false);
  const [resolver, setResolver] = useState(null);
  const [password, setPassword] = useState("");
  const [code, setCode] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    setReauthHandler(() => new Promise((resolve) => {
      setPassword(""); setCode(""); setError(""); setOpen(true);
      setResolver(() => resolve);
    }));
  }, []);

  const finish = (ok) => { setOpen(false); if (resolver) resolver(ok); setResolver(null); };

  const submit = async (e) => {
    e.preventDefault(); setError(""); setBusy(true);
    try {
      await api.post("/auth/reauth", { password, code: code || undefined });
      setBusy(false);
      finish(true);
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || "Verification failed");
      setBusy(false);
    }
  };

  if (!open) return null;
  return (
    <div className="fixed inset-0 z-[200] grid place-items-center bg-ink/60 backdrop-blur-sm p-4" data-testid="reauth-modal">
      <form onSubmit={submit} className="bg-card rounded-2xl border border-border w-full max-w-sm p-6 relative">
        <button type="button" onClick={() => finish(false)} className="absolute right-4 top-4 text-muted-foreground" data-testid="reauth-cancel"><X size={18} /></button>
        <div className="flex items-center gap-2 mb-1"><ShieldCheck size={20} className="text-emerald" /><h3 className="font-display font-bold text-lg">Confirm it's you</h3></div>
        <p className="text-sm text-muted-foreground mb-4">This is a protected action. Re-enter your password to continue.</p>
        <input type="password" autoFocus value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Password" className="w-full rounded-xl border border-border px-4 py-3 text-sm mb-3" data-testid="reauth-password" />
        <input inputMode="numeric" value={code} onChange={(e) => setCode(e.target.value)} placeholder="2FA code (if enabled)" className="w-full rounded-xl border border-border px-4 py-3 text-sm mb-3" data-testid="reauth-code" />
        {error && <p className="text-sm text-coral mb-3">{error}</p>}
        <button disabled={busy} className="w-full bg-ink text-white rounded-xl py-3 font-semibold flex items-center justify-center gap-2 disabled:opacity-60" data-testid="reauth-submit">
          {busy ? <Loader2 size={18} className="animate-spin" /> : <ShieldCheck size={16} />} Verify &amp; continue
        </button>
      </form>
    </div>
  );
};
